import { Gender, TITLE_OTHER_TH, TITLE_OTHER_EN } from "const"

// const getFirstWordOnly = (title) => title?.match(/\w+/g)?.[0]?.toLowerCase()
// const getFirstWordOnly = (title) => title?.replace(/[.]/, '').toLowerCase()

export const isTitleMale = 
  (title) => ['นาย', 'mr', 'mr.'].includes(title?.toLowerCase())

export const isTitleFemale = 
  (title) => [
    'นาง', 'นางสาว', 'น.ส.', 
    'ms', 'mrs', 'miss',
    'ms.', 'mrs.', 'miss',
  ].includes(title?.toLowerCase())

export const isTitleOther = 
  (title) => title?.trim() === TITLE_OTHER_TH || title?.trim() === TITLE_OTHER_EN

export const isMainTitleAndGenderMatched = (gender, title) => {
  return Gender.Male === gender?.toUpperCase()
    ? isTitleMale(title)
    : isTitleFemale(title)
}